import { TipoParcelaEnum } from '../components/TipoParcelaEnum';
var ParcelaImovel = /** @class */ (function () {
    function ParcelaImovel() {
        this.tipo = TipoParcelaEnum.CONVENCIONAIS;
    }
    return ParcelaImovel;
}());
export { ParcelaImovel };
